import { Component, OnDestroy, OnInit } from '@angular/core';

import { CimaCore, Util, XmStore, XmStoreUtil } from 'core/services';
import { Subscription } from 'rxjs';
import { CmsDataDetail } from 'store/cms/models';
import { User } from 'store/user/models';

@Component({
    selector: 'broadband-tablet-label',
    styleUrls: ['./broadband-tablet-label.scss'],
    templateUrl: './broadband-tablet-label.html',
    standalone: false
})
export class BroadbandTabletLabelComponent implements OnInit, OnDestroy {
    public pageData: CmsDataDetail;
    public labelDetails: LabelSegmentDetails;
    public tabletLabel: LabelDetails;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];

    constructor(xmStore: XmStore, cimaCore: CimaCore) {
        Object.assign(this, { xmStore, cimaCore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<User>(User), (user: User) => {
            this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsDataDetail>(CmsDataDetail), (pageData: CmsDataDetail) => {
                this.pageData = pageData;
                this.labelDetails = pageData.broadbandLabel.find((label: LabelSegmentDetails) => label.level === user.account.level);
                this.tabletLabel = this.labelDetails?.tabletPlan;
            }));
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
